<template>
  <div />
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
 
onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const path = urlParams.get("path");
  const token = urlParams.get("token");
  const userEmail = urlParams.get("userEmail");
  const env = urlParams.get("env");
  const redirectPathDomain = urlParams.get("redirectPathDomain");
 
  const routeMap = {
    "new-password": () => {
      const redirectParams = new URLSearchParams({
        tokenNewPassword: token || "",
        userEmail: userEmail || "",
        isValid: "true",
      });
      return `/set-password?${redirectParams.toString()}`;
    },
    "first-access": () => {
      if (redirectPathDomain) {
        return redirectPathDomain;
      }
      return null;
    },
    "login": () => {
      return "/";
    },
  };
  const envEndpointMapper = {
    "production": "com",
    "development": "dev",
    "staging": "net",
  }
 
  if (path && routeMap[path]) {
    const redirectUrl = routeMap[path]();
    if (redirectUrl) {
      if (path === "first-access") {
        window.location.href = redirectUrl;
      } else {
        const base = `https://app.voompplay.${envEndpointMapper[env] ?? "com"}.br`;
        window.location.href = base + redirectUrl;
      }
      return;
    }
  }
 
  console.warn("Unknown redirect path:", path);
  window.location.href = "/home";
});
</script>
 
<style lang="scss" scoped></style>
